import React from 'react';
import styled from 'styled-components';
import { Spinner } from '@heroui/react';

const CircularLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 50px;
  position: ${(props) => props.position || 'relative'};
  top: ${(props) => props.top || '0'};
  width: ${(props) => props.width || '100%'};
`;

const Loader = ({
  text = 'Loading...',
  position,
  top,
  width,
  loaderStyles,
}) => {
  return (
    <CircularLoader
      position={position}
      top={top}
      width={width}
      style={loaderStyles}
    >
      <Spinner label={text} size="lg" color="primary" aria-label="Loading..." />
    </CircularLoader>
  );
};

export default Loader;
